import '../styles/Home.css'

import Typewriter from 'typewriter-effect';
import {Link} from 'react-scroll';
import logo from '../images/home-logo.png';

const Home = () => {
    return (
        <div className='home'>
            <div className="home-wrapper">
                <div className="home-picture">
                    <img src={logo}/>
                </div>
                <h1>
                    <span className="typewriter-wrapper">
                        <Typewriter
                            options={{
                                autoStart: true,
                                loop: true,
                                delay: 35,
                                deleteSpeed: 0.05,
                                wrapperClassName: "typewriter",
                                cursorClassName: "typewriter-cursor"
                            }}
                            onInit={(typewriter) => {
                                typewriter
                                    .typeString("<span class='gradientText'>Creating</span>&nbsp;")
                                    .pauseFor(2000)
                                    .deleteChars(16)
                                    .pauseFor(400)
                                    .typeString("<span class='gradientText'>Making</span>&nbsp;")
                                    .pauseFor(3000)
                                    .deleteChars(14)
                                    .pauseFor(400)
                                    .typeString("<span class='gradientText'>Building</span>&nbsp;")
                                    .pauseFor(1500)
                                    .deleteChars(16)
                                    .pauseFor(400)
                                    .start()
                                ;
                            }}
                        />
                    </span>
                    <span>
                        &nbsp;Unity games.
                    </span>
                </h1>
            </div>
        </div>
    )
}

export default Home;